<p-dialog *ngIf="showDialog" [(visible)]="showDialog"
          [contentStyle]="{'overflow':'visible'}" [responsive]="true" [resizable]="false"
          [style]="PrimeNgConfig.DialogStyle65" [modal]="true" (onHide)="onClickHideMainDialog()" class="default-charge-dialog" [closable]="false">
  <form #defaultChargeCodeForm="ngForm">

    <p-header>
      <h5>Default Charge Code Setup</h5>
    </p-header>

    <div style="margin: 10px 0px">
      <div class="p-grid">
        <div class="p-col-12">
          {{ headerText }}
        </div>
      </div>
      <div class="p-grid" style="margin-top:10px;">
        <div class="p-col-12 p-md-2 p-lg-2">
          <label>{{ subTypeDropdownLabel }}<sup>*</sup></label>
        </div>
        <div class="p-col-12 p-md-10 p-lg-10">
          <p-dropdown name="selectedSubType" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [filter]="true" filterBy="label,value.name"
                      [options]="subTypeList"
                      [(ngModel)]="selectedSubType"
                      (onChange)="onChangeSubType(selectedSubType)" required></p-dropdown>
          <div *ngIf="formErrors.selectedSubType" class="alert alert-danger">
            {{ formErrors.selectedSubType }}
          </div>
        </div>
      </div>
    </div>

    <app-data-table [columns]="tableColumns" [value]="defaultChargeCodes" sortField="chargeNumber" [disableSearch]="true"
                    [rightCaptionTemplate]="rightCaptionTemplate">
      <ng-template #rightCaptionTemplate pTemplate="caption">
        <button pButton type="button" icon="fa fa-plus" class="ui-button" label="Charge Code"
                (click)="onClickAddNewChargeCode()"
                [disabled]="!selectedSubType || !selectedSubType || totalAllocation >= 100">
        </button>
      </ng-template>
      <ng-template #actionTemplate let-row="row" let-columns="columns">
        <button type="button" pButton icon="fa fa-pencil" (click)="onClickEditChargeCode(row)"></button>
        <button type="button" pButton icon="fa fa-times" (click)="onClickDeleteChargeCode(row)"></button>
      </ng-template>

    </app-data-table>


    <p-footer>
      <div style="position: absolute;right:10px;bottom: 10px;">
        <button pButton type="button" (click)="onClickHideMainDialog()" class="button-inaction" icon="fa fa-close" label="Close"></button>
        <button pButton type="submit" label="Save" class="button-action" icon="fa fa-check"
                (click)="onClickSaveDefaultChargeCodes(defaultChargeCodes)"
                [disabled]="!defaultChargeCodeForm.form.valid || (totalAllocation > 0 && totalAllocation < 100)"></button>
        <button *ngIf="totalAllocation > 0 && totalAllocation < 100"
                pButton type="button" class="icon-negative" icon="fa fa-warning" pTooltip="Allocation not 100%" tooltipPosition="top">
        </button>
      </div>
    </p-footer>
  </form>
</p-dialog>

<p-dialog header="Charge Code Details" [(visible)]="displayChargeCodeDialog" [responsive]="true" [modal]="true"
          [style]="PrimeNgConfig.DialogStyle40" [contentStyle]="{'min-height':'300px'}" class="default-charge-dialog">
  <div style="margin: 10px 0px" *ngIf="chargeCodeToEdit&&displayChargeCodeDialog">
    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Charge Code*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <app-my-charge-code-dropdown [txnType]="txnType" [authorizedFrom]="authorizedFrom" [authorizedThru]="authorizedThru" [chargeCodeId]="chargeCodeToEdit?.chargeCodeId"
                                     (handler)="handleSelectedChargeCode($event)" required></app-my-charge-code-dropdown>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Allocation*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <div class="p-inputgroup">
          <input name="allocationPercent" type="number" min="1" step="1" [max]="availableAllocation"
                 [(ngModel)]="chargeCodeToEdit.allocationPercent" required/>
          <span class="p-inputgroup-addon">%</span>
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <div style="position: absolute;right:10px;bottom: 10px;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close"
              (click)="onClickHideChargeCodeDialog()"></button>
      <button *ngIf="!chargeCodeToEdit?.id"
              pButton type="button" class="button-action" icon="fa fa-check" label="Save"
              (click)="onClickAddOrUpdateChargeCode(chargeCodeToEdit, selectedChargeCode)"
              [disabled]="!chargeCodeToEdit?.allocationPercent || (chargeCodeToEdit?.allocationPercent > availableAllocation)"></button>
      <button *ngIf="chargeCodeToEdit?.id"
              pButton type="button" class="button-action" icon="fa fa-check" label="Update"
              (click)="onClickAddOrUpdateChargeCode(chargeCodeToEdit, selectedChargeCode)"
              [disabled]="!chargeCodeToEdit?.allocationPercent|| (chargeCodeToEdit?.allocationPercent > availableAllocation)"></button>
    </div>
  </p-footer>
</p-dialog>
